import { h as __h } from "preact";
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import { pluralize } from "~/util/pluralize.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {string[]} key_ids
 */
export const deleteKeys = async ({
  orgId
}, ...key_ids) => {
  const res = await confirmModal({
    title: `Delete ${key_ids.length} ${pluralize(key_ids.length, "key")}?`,
    action: "Delete",
    body: __h("p", {}, "Machines that have already been registered using this key will not be deleted.")
  });
  if (!res) return;
  try {
    await Promise.all(key_ids.map(keyId => authedApiRequest("DELETE", `/v2/orgs/${orgId}/machine-keys/${keyId}`)));
    Query.invalidate([`/v2/orgs/${orgId}/machine-keys`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};